export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_44-8c41a3f90fe9f435d129fab89928e1fc.jpg";